export const PROJECT_BATCH_IMAGES = {
  "/projects/ann-arbor-subfloor": {
    "file": "ProjectAnnArbor",
    "share": {
      "url": "https://1woodfloors.com/images/projects/self-leveling-underlayment-deep-pour-ann-arbor-mi.jpg",
      "width": 768,
      "height": 1024,
      "alt": "Hallway with a 1.5 inch deep self leveling underlayment pour, Ann Arbor, MI"
    },
    "photos": [
      {
        "baseName": "deep-self-leveling-underlayment-pour-ann-arbor-mi",
        "alt": "Finished surface of a 1.5 inch Schönox self leveling underlayment pour, Ann Arbor, MI",
        "url": "https://1woodfloors.com/images/projects/self-leveling-underlayment-deep-pour-ann-arbor-mi.jpg"
      },
      {
        "baseName": "schonox-collomix-subfloor-leveling-1-wood-floors",
        "alt": "Mixing station for a 1.5 inch Schönox self leveling underlayment pour, Ann Arbor, MI"
      },
      {
        "baseName": "hepa-vacuum-dust-control-mixing-station-1-wood-floors",
        "alt": "HEPA vacuum dust control at the mixer for a 1.5 inch Schönox self leveling underlayment pour, Ann Arbor, MI"
      },
      {
        "baseName": "deep-self-leveling-underlayment-pour-ann-arbor-mi",
        "alt": "Close view of a 1.5 inch Schönox self leveling underlayment pour, Ann Arbor, MI"
      }
    ],
    "primary": 0
  },
  "/projects/ann-arbor-tech": {
    "file": "ProjectAnnArborTech",
    "share": {
      "url": "https://1woodfloors.com/images/projects/commercial-oak-staircase-pallmann-magic-oil-ann-arbor-mi.jpg",
      "width": 414,
      "height": 414,
      "alt": "Commercial staircase and engineered oak floor refinished with Pallmann Magic Oil, Ann Arbor, MI"
    },
    "photos": [
      {
        "baseName": "commercial-ann-arbor",
        "alt": "Commercial hardwood floor refinishing on a 2mm engineered oak wear layer with Pallmann Magic Oil, Ann Arbor, MI",
        "url": "https://1woodfloors.com/images/projects/commercial-oak-staircase-pallmann-magic-oil-ann-arbor-mi.jpg"
      },
      {
        "baseName": "ann-arbor-tech-floor-detail",
        "alt": "Floor detail of a commercial hardwood floor refinished with Pallmann Magic Oil in Almond, Ann Arbor, MI"
      },
      {
        "baseName": "ann-arbor-tech-staircase",
        "alt": "Custom staircase in an office with a commercial hardwood floor refinished with Pallmann Magic Oil, Ann Arbor, MI"
      },
      {
        "baseName": "ann-arbor-tech-open-floor",
        "alt": "Open plan area of a commercial hardwood floor refinished with Pallmann Magic Oil, Ann Arbor, MI"
      },
      {
        "baseName": "ann-arbor-tech-lobby",
        "alt": "Lobby with wood wall paneling and a commercial hardwood floor refinished with Pallmann Magic Oil, Ann Arbor, MI"
      },
      {
        "baseName": "commercial-ann-arbor",
        "alt": "Grand staircase of a commercial hardwood floor refinished with Pallmann Magic Oil, Ann Arbor, MI"
      },
      {
        "baseName": "ann-arbor-tech-staircase-levels",
        "alt": "Three level staircase with perforated steel railings over a commercial hardwood floor refinished with Pallmann Magic Oil, Ann Arbor, MI"
      },
      {
        "baseName": "ann-arbor-tech-staircase-aerial",
        "alt": "Overhead view of a staircase landing in a commercial hardwood floor refinished with Pallmann Magic Oil, Ann Arbor, MI"
      }
    ],
    "primary": 0
  },
  "/projects/harbor-springs-maple": {
    "file": "ProjectHarborSprings",
    "share": {
      "url": "https://1woodfloors.com/images/projects/maple-floor-invisible-finish-vaulted-room-harbor-springs-mi.jpg",
      "width": 886,
      "height": 886,
      "alt": "Vaulted room with a maple floor in an invisible finish, Harbor Springs, MI"
    },
    "photos": [
      {
        "baseName": "harbor-springs-invisible-maple-vaulted",
        "alt": "Vaulted room with refinished northern maple in an invisible finish, Harbor Springs, MI",
        "url": "https://1woodfloors.com/images/projects/maple-floor-invisible-finish-vaulted-room-harbor-springs-mi.jpg"
      },
      {
        "baseName": "harbor-springs-maple-turret",
        "alt": "Curved turret bay window room with refinished northern maple in an invisible finish, Harbor Springs, MI"
      },
      {
        "baseName": "harbor-springs-maple-great-room",
        "alt": "Great room overlooking Little Traverse Bay with refinished northern maple in an invisible finish, Harbor Springs, MI"
      },
      {
        "baseName": "harbor-springs-maple-turret",
        "alt": "Curved turret bay window room with refinished northern maple in an invisible finish, Harbor Springs, MI"
      },
      {
        "baseName": "harbor-springs-maple-staircase",
        "alt": "Staircase and custom handrail with refinished northern maple in an invisible finish, Harbor Springs, MI"
      },
      {
        "baseName": "harbor-springs-maple-staircase-aerial",
        "alt": "Overhead view of staircase landings with refinished northern maple in an invisible finish, Harbor Springs, MI"
      },
      {
        "baseName": "harbor-springs-maple-hallway-vaulted",
        "alt": "Vaulted hallway with refinished northern maple in an invisible finish, Harbor Springs, MI"
      },
      {
        "baseName": "harbor-springs-maple-hallway",
        "alt": "Long hallway with refinished northern maple in an invisible finish, Harbor Springs, MI"
      },
      {
        "baseName": "harbor-springs-maple-doorway",
        "alt": "Doorway transition with refinished northern maple in an invisible finish, Harbor Springs, MI"
      }
    ],
    "primary": 0
  },
  "/projects/livonia-subfloor": {
    "file": "ProjectLivonia",
    "share": {
      "url": "https://1woodfloors.com/images/projects/self-leveling-underlayment-pour-concrete-livonia-mi.jpg",
      "width": 1024,
      "height": 768,
      "alt": "Self leveling underlayment poured over primed concrete, Livonia, MI"
    },
    "photos": [
      {
        "baseName": "engineered-self-leveling-underlayment-concrete-livonia",
        "alt": "Pour of self leveling underlayment over old mastic on primed concrete, Livonia, MI",
        "url": "https://1woodfloors.com/images/projects/self-leveling-underlayment-pour-concrete-livonia-mi.jpg"
      },
      {
        "baseName": "subfloor-bonding-primer-over-mastic-livonia-mi",
        "alt": "Bonding primer before the pour of self leveling underlayment over old mastic, Livonia, MI"
      },
      {
        "baseName": "engineered-self-leveling-underlayment-concrete-livonia",
        "alt": "Finished pour of self leveling underlayment over old mastic, Livonia, MI"
      },
      {
        "baseName": "custom-8-inch-hickory-hardwood-michigan-plank-fireside",
        "alt": "Custom 8 inch Michigan Plank hickory floor in Fireside over leveled concrete, Livonia, MI"
      },
      {
        "baseName": "michigan-plank-hickory-fireside-dining-table-livonia-mi",
        "alt": "Dining table and Windsor chairs on an 8 inch engineered Michigan Plank hickory floor in Fireside, Livonia, MI",
        "url": "https://1woodfloors.com/images/projects/livonia-subfloor/michigan-plank-hickory-fireside-dining-table-livonia-mi.webp"
      },
      {
        "baseName": "michigan-plank-hickory-fireside-living-room-sofa-livonia-mi",
        "alt": "Leather sofa on a wide 8 inch engineered Michigan Plank hickory floor in Fireside, Livonia, MI",
        "url": "https://1woodfloors.com/images/projects/livonia-subfloor/michigan-plank-hickory-fireside-living-room-sofa-livonia-mi.webp"
      },
      {
        "baseName": "michigan-plank-hickory-fireside-dining-hutch-livonia-mi",
        "alt": "Pine hutch against a green wall on an 8 inch Michigan Plank hickory floor in Fireside, Livonia, MI",
        "url": "https://1woodfloors.com/images/projects/livonia-subfloor/michigan-plank-hickory-fireside-dining-hutch-livonia-mi.webp"
      },
      {
        "baseName": "michigan-plank-hickory-fireside-long-boards-sideboard-livonia-mi",
        "alt": "Long runs of 8 inch engineered Michigan Plank hickory boards in Fireside beside a pine sideboard, Livonia, MI",
        "url": "https://1woodfloors.com/images/projects/livonia-subfloor/michigan-plank-hickory-fireside-long-boards-sideboard-livonia-mi.webp"
      },
      {
        "baseName": "michigan-plank-hickory-fireside-grain-closeup-livonia-mi",
        "alt": "Close view of knots and grain in an 8 inch Michigan Plank hickory floor in Fireside, Livonia, MI",
        "url": "https://1woodfloors.com/images/projects/livonia-subfloor/michigan-plank-hickory-fireside-grain-closeup-livonia-mi.webp"
      }
    ],
    "primary": 0
  },
  "/projects/northville-walnut": {
    "file": "ProjectNorthvilleWalnut",
    "share": {
      "url": "https://1woodfloors.com/images/projects/walnut-fas-8-inch-floor-open-kitchen-northville-mi.jpg",
      "width": 886,
      "height": 886,
      "alt": "Open kitchen with an 8 inch engineered FAS walnut floor, Northville, MI"
    },
    "photos": [
      {
        "baseName": "northville-walnut-open-floor-kitchen",
        "alt": "Open kitchen and living area with an 8 inch wide plank FAS walnut floor, Northville, MI",
        "url": "https://1woodfloors.com/images/projects/walnut-fas-8-inch-floor-open-kitchen-northville-mi.jpg"
      },
      {
        "baseName": "northville-walnut-great-room-fireplace",
        "alt": "Great room with a stone fireplace on an 8 inch wide plank FAS walnut floor, Northville, MI"
      },
      {
        "baseName": "northville-walnut-kitchen-island",
        "alt": "Kitchen with a center island on an 8 inch wide plank FAS walnut floor, Northville, MI"
      },
      {
        "baseName": "northville-walnut-dining-chandelier",
        "alt": "Formal dining room with a crystal chandelier on an 8 inch wide plank FAS walnut floor, Northville, MI"
      },
      {
        "baseName": "northville-walnut-grain-closeup",
        "alt": "Close view of FAS walnut grain under Pallmann Magic Oil 2K, Northville, MI"
      },
      {
        "baseName": "northville-walnut-fireplace-wide",
        "alt": "Wide view of a fireplace and built ins with an 8 inch wide plank FAS walnut floor, Northville, MI"
      },
      {
        "baseName": "northville-walnut-slu-pour",
        "alt": "Schönox self leveling underlayment pour before the walnut floor, Northville, MI"
      },
      {
        "baseName": "northville-walnut-slu-craftsman",
        "alt": "Craftsman spreading self leveling underlayment before the walnut floor, Northville, MI"
      },
      {
        "baseName": "bare-plywood-subfloor-evaluation-1-wood-floors-northville-mi",
        "alt": "Bare plywood evaluation before self leveling underlayment, Northville, MI"
      },
      {
        "baseName": "specialized-blue-subfloor-primer-1-wood-floors",
        "alt": "Blue bonding primer on plywood before self leveling underlayment, Northville, MI"
      }
    ],
    "primary": 0
  },
  "/projects/plymouth-custom-white-oak": {
    "file": "ProjectPlymouth",
    "share": {
      "url": "https://1woodfloors.com/images/projects/white-oak-8-inch-custom-line-floor-kitchen-plymouth-mi.jpg",
      "width": 2400,
      "height": 1600,
      "alt": "Kitchen with an 8 inch engineered 1 Wood Floors Custom Line white oak floor in Sand, Plymouth, MI"
    },
    "photos": [
      {
        "baseName": "1-wood-custom-line-8-inch-white-oak-plymouth-mi",
        "alt": "Custom 8 inch wide plank character grade white oak floor with a 4.5mm sawn face, Plymouth, MI",
        "url": "https://1woodfloors.com/images/projects/white-oak-8-inch-custom-line-floor-kitchen-plymouth-mi.jpg"
      },
      {
        "baseName": "plymouth-custom-white-oak-kitchen-island",
        "alt": "Open kitchen with a navy island and gold fixtures on a custom 8 inch white oak floor in Sand, Plymouth, MI"
      },
      {
        "baseName": "plymouth-custom-white-oak-living-room",
        "alt": "Living room with contemporary art and a mirrored credenza on a custom 8 inch white oak floor in Sand, Plymouth, MI"
      },
      {
        "baseName": "plymouth-custom-white-oak-floor-detail",
        "alt": "Close view of the grain and 4.5mm sawn face of a custom 8 inch white oak floor in Sand, Plymouth, MI"
      },
      {
        "baseName": "plymouth-custom-white-oak-aerial-seating",
        "alt": "Overhead view of a seating area and sheepskin rug on a custom 8 inch white oak floor in Sand, Plymouth, MI"
      },
      {
        "baseName": "plymouth-custom-white-oak-stair-detail",
        "alt": "Stair nosing and riser detail matched to a custom 8 inch white oak floor in Sand, Plymouth, MI"
      },
      {
        "baseName": "plymouth-custom-white-oak-kitchen-range",
        "alt": "Kitchen with navy cabinets and a professional range on a custom 8 inch white oak floor in Sand, Plymouth, MI"
      }
    ],
    "primary": 0
  },
  "/subfloor-leveling": {
    "file": "SubfloorLeveling",
    "share": {
      "url": "https://1woodfloors.com/images/projects/self-leveling-underlayment-pour-concrete-livonia-mi.jpg",
      "width": 1024,
      "height": 768,
      "alt": "Self leveling underlayment poured over primed concrete, Livonia, MI"
    },
    "photos": [
      {
        "baseName": "needle-rolling-self-leveling-underlayment-1-wood-floors-northville",
        "alt": "Ed Malaski needle rolling self leveling underlayment, Northville, MI"
      },
      {
        "baseName": "method-joist-repair",
        "alt": "Floor joists being inspected and repaired to correct structural dips"
      },
      {
        "baseName": "method-hard-shim",
        "alt": "Hard shim technique with layered plywood and wood shims correcting subfloor low spots"
      },
      {
        "baseName": "subfloor-bonding-primer-over-mastic-livonia-mi",
        "alt": "Bonding primer applied over existing concrete mastic, Livonia, MI"
      },
      {
        "baseName": "engineered-self-leveling-underlayment-concrete-livonia",
        "alt": "Glossy self leveling underlayment poured over a primed concrete subfloor, Livonia, MI",
        "url": "https://1woodfloors.com/images/projects/self-leveling-underlayment-pour-concrete-livonia-mi.jpg"
      },
      {
        "baseName": "custom-8-inch-hickory-hardwood-michigan-plank-fireside",
        "alt": "8 inch wide plank Michigan Plank hickory floor in Fireside, Livonia, MI"
      },
      {
        "baseName": "bare-plywood-subfloor-evaluation-1-wood-floors-northville-mi",
        "alt": "Bare plywood subfloor checked for flatness before leveling, Northville, MI"
      },
      {
        "baseName": "specialized-blue-subfloor-primer-1-wood-floors",
        "alt": "Blue subfloor bonding primer buckets on a bare subfloor, Northville, MI"
      },
      {
        "baseName": "needle-rolling-self-leveling-underlayment-1-wood-floors-northville",
        "alt": "Ed Malaski spreading self leveling underlayment with a needle roller, Northville, MI"
      },
      {
        "baseName": "deep-self-leveling-underlayment-pour-ann-arbor-mi",
        "alt": "Deep self leveling underlayment pour correcting a 1.5 inch height variance, Ann Arbor, MI"
      },
      {
        "baseName": "needle-rolling-self-leveling-underlayment-1-wood-floors-northville",
        "alt": "Needle roller releasing air from self leveling underlayment, Northville, MI"
      },
      {
        "baseName": "engineered-self-leveling-underlayment-concrete-livonia",
        "alt": "Self leveling underlayment poured over primed concrete, Livonia, MI"
      }
    ],
    "primary": 4
  }
};

export const PROJECT_BATCH_SHARE_IMAGES = Object.fromEntries(Object.entries(PROJECT_BATCH_IMAGES).map(([path, record]) => [path, record.share]));
export function uniqueProjectPhotos(path) {
  const record = PROJECT_BATCH_IMAGES[path];
  if (!record) return [];
  const seen = new Set();
  return record.photos.filter(photo => {
    if (seen.has(photo.baseName)) return false;
    seen.add(photo.baseName);
    return true;
  });
}
export function makeProjectBatchSchemas(path, resolveImage) {
  const record = PROJECT_BATCH_IMAGES[path];
  if (!record) return [];
  const images = uniqueProjectPhotos(path).map(photo => {
    const url = photo.url || resolveImage(photo.baseName);
    return { "@context": "https://schema.org", "@type": "ImageObject", "@id": `https://1woodfloors.com${path}#photo-${photo.baseName}`, contentUrl: url, url, caption: photo.alt, creditText: "1 Wood Floors", creator: { "@id": "https://1woodfloors.com/#organization" }, copyrightHolder: { "@id": "https://1woodfloors.com/#organization" } };
  });
  return [...images, { "@context": "https://schema.org", "@type": "WebPage", url: `https://1woodfloors.com${path}`, primaryImageOfPage: { "@id": `https://1woodfloors.com${path}#photo-${record.photos[record.primary].baseName}` } }];
}
